export default __webpack_public_path__ + "static/media/flickr-logo-transparent-white.eea5567d.png";